module.exports = __webpack_public_path__ + "img/embarrassment.8c79e263.png";